import React from "react";
import { Row, Col, Badge } from "react-bootstrap";
import { array, object, number } from "prop-types";
import AverageScoreScale from "components/DynamicScoreReportScales/AverageScoreScale";
import { testIdToTestAbbreviation } from "containers/Results/FunctionLib";

const EmotifyCognifyUCognify = (props) => {
  // ---------------------------- Prop Deconstruction ---------------------------
  const {
    candidateInfo,
    reportText,
    SelectedScoreRangeSection,
    SubcategoryScoreColumns,
    testId,
    testScores,
  } = props;

  // ---------------------------- Results Details ---------------------------
  const getResultsDetails = () => {
    const firstName = candidateInfo.get("testTakerFirstName");
    const percentile = testScores.get("percentile");

    return (
      <Row>
        <Col>
          <h3 className="reportHeader mt-4">Results Details</h3>
          <div className="px-3 pb-3">
            <AverageScoreScale score={percentile} testId={testId} />
          </div>
          {SelectedScoreRangeSection ? (
            <div className="mx-3">
              <hr className="divider" />
              {SelectedScoreRangeSection}
              <hr className="divider" />
            </div>
          ) : null}
          <p>
            {`${firstName}'s overall ${testIdToTestAbbreviation[testId]} score was higher than ${percentile} percent of the general population, which indicates that they are likely to:`}
          </p>
          <ul className="double-list">
            {reportText.get("details").map((list, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <li key={i}>{list}</li>
            ))}
          </ul>
          <hr className="divider my-4" />
        </Col>
      </Row>
    );
  };

  // ---------------------------- Score Details ---------------------------
  const getScoreDetails = () => (
    <Row>
      <Col>
        <h3 className="reportHeader">Score Details</h3>
        <div className="d-flex">{SubcategoryScoreColumns}</div>
      </Col>
    </Row>
  );

  // ---------------------------- Interview Questions ----------------------------
  const getInterviewQuestions = () => {
    if (!reportText) {
      return "";
    }

    const GeneralQuestions = getQuestionText("General");
    const PerceivingQuestions = getQuestionText("Perceiving");
    const UnderstandingQuestions = getQuestionText("Understanding");
    const ManagingQuestions = getQuestionText("Managing");

    return (
      <Row>
        <Col>
          <hr className="divider my-4" />
          <h3 className="reportHeader mb-3">Interview Questions</h3>
          <p>{reportText.get("generalQuestionsNote")}</p>
          {GeneralQuestions}
          {PerceivingQuestions}
          {UnderstandingQuestions}
          {ManagingQuestions}
        </Col>
      </Row>
    );
  };

  const getQuestionText = (questionTitle) => {
    const isGeneral = questionTitle === "General";
    const questionKey = `${
      questionTitle === "Understanding" // the understanding text information is stored under understandQuestions instead of understandingQuestions
        ? "understand"
        : questionTitle.toLowerCase()
    }Questions`;

    // If for whatever reason the key does not exist return null instead of breaking
    if (!reportText.get(questionKey)) {
      return null;
    }

    const questionListItems = reportText
      .get(questionKey)
      .map((question, idx) => <li key={idx}>{question}</li>); // eslint-disable-line react/no-array-index-key

    // Here General should be the exception so that we don't show that text below, matching the pdf
    const questionNote = !isGeneral
      ? reportText.get(`${questionKey}Note`)
      : null;

    return (
      <div key={questionTitle}>
        <Badge className="badge badge-interview">
          {questionTitle}
          {isGeneral ? " Emotions" : ""}
        </Badge>
        {questionNote ? (
          <p className="ml-2">
            <strong>Note to interviewer:</strong> {questionNote}
          </p>
        ) : null}
        <ul className="mt-2">{questionListItems}</ul>
      </div>
    );
  };

  return (
    <div>
      {getResultsDetails()}
      {getScoreDetails()}
      {(testId === 44 || testId === 51) && getInterviewQuestions()}
    </div>
  );
};

EmotifyCognifyUCognify.propTypes = {
  SelectedScoreRangeSection: object,
  SubcategoryScoreColumns: array,
  reportText: object,
  candidateInfo: object,
  testId: number,
  testScores: object,
};

export default EmotifyCognifyUCognify;
